import React, { useState, useContext } from 'react';
import Box from '../../../elements/Box';
import Row from '../../../elements/Row';
import Col from '../../../elements/Col';
import Link from '../../../elements/Link';
import Button from '../../../elements/Button';
import SectionHeadItem from './SectionHeadItem';
import SectionBodyItem from './SectionBodyItem';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import useHandleSectionNavigation from './../hooks/a11y';

import { Item } from '@react-stately/collections';
import { useTab, useTabList, useTabPanel } from '@react-aria/tabs';
import { useTabListState } from '@react-stately/tabs';

import { isInInterval, isValidDeviceSetting, transformLabel } from './../utils/utils';

const KEY_ARROW_LEFT = 37;
const KEY_ARROW_UP = 38;
const KEY_ARROW_RIGHT = 39;
const KEY_ARROW_DOWN = 40;
const KEY_ENTER = 13;
const KEY_SPACE = 32;

const Sections = (props) => {
  const {
    data,
    containerSettings,
    headerSettings: baseHeaderSettings,
    headerSettingsTablet = {},
    headerSettingsDesktop = {},
    headerSettingsMobile = {},
    bodySettings,
    tabListSettings,
    tabSettings,
    tabPanelSettings,
    selectedTabBarSettings: baseSelectedTabBarSettings,
    mobileSelectedTabBarSettings = {},
    tabletSelectedTabBarSettings = {},
    desktopSelectedTabBarSettings = {},
    isMobile,
    deviceViewPortSize,
    containerWidth,
    scrollIntoViewSettings = {
      useNativeFunction: undefined
    },
    dispatch
  } = props;
  const { translate } = useContext(Context);

  let selectedTabBarSettings = {
    ...baseSelectedTabBarSettings
  };

  let headerSettings = {
    ...baseHeaderSettings
  };

  let isTabletViewPort = false;

  if (deviceViewPortSize !== null && deviceViewPortSize !== undefined && isMobile) {
    const { mobile, desktop, tablet } = deviceViewPortSize;
    if (isValidDeviceSetting(mobile) && isInInterval(containerWidth, mobile)) {
      selectedTabBarSettings = {
        ...mobileSelectedTabBarSettings
      };
      headerSettings = { ...headerSettingsMobile };
      isTabletViewPort = false;
    } else if (isValidDeviceSetting(tablet) && isInInterval(containerWidth, tablet)) {
      selectedTabBarSettings = {
        ...tabletSelectedTabBarSettings
      };
      headerSettings = { ...headerSettingsTablet };
      isTabletViewPort = true;
    } else if (isValidDeviceSetting(desktop) && isInInterval(containerWidth, desktop)) {
      selectedTabBarSettings = {
        ...desktopSelectedTabBarSettings
      };
      isTabletViewPort = false;
      headerSettings = { ...headerSettingsDesktop };
    }
  }

  function Tabs(props) {
    const { direction, theme } = useContext(Context);
    const [className, style] = useStyles(props, { direction, theme });
    const [tabIndex, setTabIndex] = React.useState(props.currentTab);
    const currentTabRef = React.useRef(null);
    const [isShowPanels, setIsShowPanels] = useState(false);
    const [selectTabPanelTabIndex, setSelectTabPanelTabIndex] = useState(-1);
    let scollToRef = React.useRef();
    const onClick = (index) => {
      setIsShowPanels(tabIndex === index ? !isShowPanels : true);
      setSelectTabPanelTabIndex(0);
      if (tabIndex === index && !isShowPanels === false) {
        setTabIndex(-1);
        state?.setSelectedKey(`-1`);
        /*  state?.selectionManager?.state?.setFocusedKey(0); */
      } else {
        setTabIndex(index);
        state?.setSelectedKey(`${index}`);
        state?.selectionManager?.state?.setFocusedKey(`${index}`);
        if (scrollIntoViewSettings.useNativeFunction !== false) {
          setTimeout(
            () => {
              if (scollToRef?.current !== null && scollToRef?.current !== undefined) {
                scollToRef?.current?.scrollIntoView();
              }
            },
            scrollIntoViewSettings.delayToScrollToPanel !== undefined
              ? scrollIntoViewSettings.delayToScrollToPanel
              : 300
          );
          setTimeout(
            () => {
              if (scollToRef?.current !== null && scollToRef?.current !== undefined) {
                scollToRef?.current?.focusTabPanels();
              }
            },
            scrollIntoViewSettings.delayToFocusPanel !== undefined
              ? scrollIntoViewSettings.delayToFocusPanel
              : 750
          );
        }
      }
    };
    const onKeyDown = (index) => {
      setIsShowPanels(!isShowPanels);
      if (!isShowPanels === false) {
        setTabIndex(-1);
      } else {
        setTabIndex(index);
      }
    };
    let state = useTabListState(props);
    let ref = React.useRef();
    let { tabListProps } = useTabList(props, state, ref);
    tabListProps = {
      ...tabListProps,
      ariaLabel: translate('cmp-travel-guide-sections-tab-list-aria-label', 'Sections'),
      ariaOrientation: tabListProps['aria-orientation']
    };
    const [idSelectedTab, setIdSelectedTab] = useState('');
    const scrollIntoView = () => {
      setTimeout(
        () => {
          if (ref?.current !== null && ref?.current !== undefined) {
            if (
              scrollIntoViewSettings.useNativeFunction === undefined ||
              scrollIntoViewSettings.useNativeFunction === null
            ) {
              ref?.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
            } else if (scrollIntoViewSettings.useNativeFunction === true) {
              window.scroll({
                top: ref?.current?.getBoundingClientRect().top + window.scrollY,
                left: 0,
                behavior: 'smooth'
              });
            }
          }
        },
        scrollIntoViewSettings.delayToScrollToTab !== undefined
          ? scrollIntoViewSettings.delayToScrollToTab
          : 250
      );
      setTimeout(
        () => {
          if (currentTabRef?.current !== null && currentTabRef?.current !== undefined) {
            currentTabRef?.current?.focus();
          }
        },
        scrollIntoViewSettings.delayToFocusTab !== undefined
          ? scrollIntoViewSettings.delayToFocusTab
          : 600
      );
    };
    const { footerContainerSettings, topButtonSettings } = bodySettings;
    return (
      <>
        <Row
          {...tabListProps}
          focusReferences={(reference) => {
            ref.current = reference;
          }}
          style={style}
          className={className}
          id="tab-list-container"
        >
          {[...state.collection].map((item, index) => (
            <Tab
              key={item.key}
              item={item}
              state={state}
              section={data[index]}
              onClick={onClick}
              onKeyDown={onKeyDown}
              setTabIndex={setTabIndex}
              tabIndex={tabIndex}
              isShowPanels={isShowPanels}
              setIsShowPanels={setIsShowPanels}
              index={index}
              setIdSelectedTab={setIdSelectedTab}
              totalItems={[...state.collection].length}
              tabSettings={tabSettings}
              selectedTabBarSettings={selectedTabBarSettings}
              isMobile={isMobile}
              isTabletViewPort={isTabletViewPort}
              currentTabRef={currentTabRef}
              setSelectTabPanelTabIndex={setSelectTabPanelTabIndex}
              itemsList={data}
            />
          ))}
        </Row>
        {isShowPanels && (
          <TabPanel
            key={state.selectedItem?.key}
            state={state}
            idSelectedTab={idSelectedTab}
            tabPanelSettings={tabPanelSettings}
            footerContainerSettings={footerContainerSettings}
            topButtonSettings={topButtonSettings}
            scrollIntoView={scrollIntoView}
            ref={scollToRef}
            tabIndex={selectTabPanelTabIndex}
          />
        )}
      </>
    );
  }

  function Tab({
    item,
    state,
    section,
    onClick,
    onKeyDown,
    tabIndex,
    isShowPanels,
    index,
    onFocus,
    setIndex,
    setIsShowPanels,
    totalItems,
    setTabIndex,
    setIdSelectedTab,
    tabSettings,
    selectedTabBarSettings,
    isMobile,
    isTabletViewPort,
    currentTabRef,
    setSelectTabPanelTabIndex,
    itemsList,
    ...props
  }) {
    const { direction, theme } = useContext(Context);
    const [className, style] = useStyles(props, { direction, theme });
    const handleKeyDown = useHandleSectionNavigation({
      state,
      setTabIndex,
      onKeyDown,
      setIsShowPanels,
      isShowPanels,
      index,
      totalItems,
      setSelectTabPanelTabIndex
    });
    let { key } = item;
    let ref = React.useRef();
    let { tabProps } = useTab({ key }, state, ref);
    let isSelected = tabIndex === index && isShowPanels;
    if (isSelected) {
      setIdSelectedTab(tabProps.id);
      currentTabRef.current = ref.current;
    }
    const newTabProps = {
      ...tabProps,
      ariaSelected: isSelected,
      ariaControls: isShowPanels ? tabProps['aria-controls'] : null,
      ariaDisabled: tabProps['aria-disabled']
    };

    return (
      <Col
        xs="6"
        ms="6"
        md="6"
        lg="3"
        {...newTabProps}
        focusReferences={(reference) => {
          ref.current = reference;
        }}
        className={`${isSelected ? 'fr-tab-selected' : ''} ${className}`}
        style={style}
        onClick={(e) => {
          if (scrollIntoViewSettings.useNativeFunction !== false) {
            dispatch({
              type: 'SELECT_INTEREST',
              payload: {
                category: 'Point of interest',
                selected: transformLabel(section.title),
                eventType: 'click'
              }
            });
            onClick(index);
          }
        }}
        onKeyDown={(e) => {
          handleKeyDown(e);
          if (itemsList && itemsList.length !== 0) {
            if (
              e.keyCode === KEY_ARROW_RIGHT ||
              e.keyCode === KEY_ARROW_DOWN ||
              e.keyCode === KEY_ARROW_LEFT ||
              e.keyCode === KEY_ARROW_UP
            ) {
              if (e.keyCode === KEY_ARROW_RIGHT || e.keyCode === KEY_ARROW_DOWN) {
                dispatch({
                  type: 'SELECT_INTEREST',
                  payload: {
                    category: 'Point of interest',
                    selected: transformLabel(
                      itemsList[
                        state.selectedItem.nextKey ? parseInt(state.selectedItem.nextKey) : 0
                      ].title
                    ),
                    eventType: 'key press'
                  }
                });
              } else {
                dispatch({
                  type: 'SELECT_INTEREST',
                  payload: {
                    category: 'Point of interest',
                    selected: transformLabel(
                      itemsList[
                        state.selectedItem.prevKey
                          ? parseInt(state.selectedItem.prevKey)
                          : itemsList.length - 1
                      ].title
                    ),
                    eventType: 'key press'
                  }
                });
              }
            } else if (e.keyCode === KEY_ENTER || (e.keyCode === KEY_SPACE && !isShowPanels)) {
              dispatch({
                type: 'SELECT_INTEREST',
                payload: {
                  category: 'Point of interest',
                  selected: transformLabel(section.title),
                  eventType: 'key press'
                }
              });
            }
          }
        }}
        {...tabSettings}
      >
        {scrollIntoViewSettings.useNativeFunction === false ? (
          <Link
            onClick={(e) => {
              onClick(index);
            }}
            href={tabProps['aria-controls'] !== undefined ? '#' + tabProps['aria-controls'] : '#'}
            className="fr-link-section"
            target="_self"
          >
            <SectionHeadItem
              {...section}
              {...headerSettings}
              isSelected={isSelected}
              isShowPanels={isShowPanels}
              selectedTabBarSettings={selectedTabBarSettings}
              isMobile={isMobile}
              isTabletViewPort={isTabletViewPort}
            ></SectionHeadItem>
          </Link>
        ) : (
          <SectionHeadItem
            {...section}
            {...headerSettings}
            isSelected={isSelected}
            isShowPanels={isShowPanels}
            selectedTabBarSettings={selectedTabBarSettings}
            isMobile={isMobile}
            isTabletViewPort={isTabletViewPort}
          ></SectionHeadItem>
        )}
      </Col>
    );
  }

  const TabPanel = React.forwardRef(
    (
      {
        state,
        idSelectedTab,
        tabPanelSettings,
        footerContainerSettings,
        scrollIntoView,
        tabIndex,
        topButtonSettings,
        ...props
      },
      ref
    ) => {
      let reference = React.useRef();
      let { tabPanelProps } = useTabPanel(props, state, reference);
      tabPanelProps = {
        ...tabPanelProps,
        ariaSelected: tabPanelProps['aria-selected'],
        ariaControls: tabPanelProps['aria-controls'],
        ariaDisabled: tabPanelProps['aria-disabled'],
        ariaLabelledBy: idSelectedTab !== '' ? idSelectedTab : null
      };

      React.useImperativeHandle(ref, () => ({
        scrollIntoView: () => {
          if (reference?.current !== null && reference?.current !== undefined) {
            if (
              scrollIntoViewSettings.useNativeFunction === undefined ||
              scrollIntoViewSettings.useNativeFunction === null
            ) {
              reference?.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
            } else if (scrollIntoViewSettings.useNativeFunction === true) {
              window.scroll({
                top: reference?.current?.getBoundingClientRect().top + window.scrollY,
                left: 0,
                behavior: 'smooth'
              });
            }
          }
        },
        focusTabPanels: () => {
          if (reference?.current !== null && reference?.current !== undefined) {
            reference?.current?.focus();
          }
        }
      }));

      return (
        <Box
          className="fr-tab-panel"
          {...tabPanelProps}
          focusReferences={(a) => {
            reference.current = a;
          }}
          tabIndex={tabIndex}
          {...tabPanelSettings}
        >
          {state.selectedItem?.props.children}
          <Box
            {...footerContainerSettings}
            focusReferences={(b) => {
              ref.current = b;
            }}
          >
            {scrollIntoViewSettings.useNativeFunction === false ? (
              <Link
                onClick={(e) => {
                  scrollIntoView();
                }}
                href="#tab-list-container"
                className="fr-top-button-section"
                target="_self"
                {...topButtonSettings}
              >
                {translate('cmp-travel-guide-top-button', '[Top]')}
              </Link>
            ) : (
              <Button
                onClick={() => {
                  scrollIntoView();
                }}
                className="fr-top-button-section"
                role="link"
                ariaLabel={translate('cmp-travel-guide-top-button-a11y', 'Go to top same page')}
                {...topButtonSettings}
              >
                {translate('cmp-travel-guide-top-button', '[Top]')}
              </Button>
            )}
          </Box>
        </Box>
      );
    }
  );

  return (
    <Box {...containerSettings} dataTestId="travelsGuideFirstSection">
      <Tabs
        {...tabListSettings}
        tabSettings={tabSettings}
        tabPanelSettings={tabPanelSettings}
        selectedTabBarSettings={selectedTabBarSettings}
        footerContainerSettings={bodySettings.footerContainerSettings}
      >
        {data.map((_, index) => (
          <Item key={index}>
            {data[index].items.map((item) => {
              return (
                <SectionBodyItem dispatch={dispatch} {...item} {...bodySettings}></SectionBodyItem>
              );
            })}
          </Item>
        ))}
      </Tabs>
    </Box>
  );
};

export default Sections;
